// Constants
import APP_CONSTANTS_COMMONS from './app.constants.commons';

export { MONTH_YEAR_DATE_NUMERIC_FORMAT } from './app.constants.commons';

export default {
  ...APP_CONSTANTS_COMMONS,
  IS_CC: false,
};
